var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.404 2.993c.466-.466.7-.699.957-.81a1.47 1.47 0 0 1 1.166 0c.258.111.491.344.957.81s.7.7.81.958c.161.372.161.793 0 1.165-.11.259-.344.492-.81.958L13.5 10.059c-.982.982-1.473 1.473-2.088 1.764s-1.306.359-2.688.495l-.625.062.061-.626c.137-1.381.205-2.072.496-2.687.29-.615.782-1.106 1.764-2.088z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M5.714 12.383H3.928a1.389 1.389 0 1 0 0 2.778h7.54a1.389 1.389 0 1 1 0 2.777H9.682"
  }))));
};
export default SvgEdit;